import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Phone, Mail, MapPin } from 'lucide-react';

const ContactForm = () => {
  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-white to-amber-50" data-testid="contact-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Get In Touch
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Ready to place an order or have questions about our delicious lumpia?
            Reach out by text, call, or email — I'd love to hear from you!
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Contact Information */}
          <Card className="bg-white border-2 border-indigo-200 shadow-lg" data-testid="contact-info-card">
            <CardHeader>
              <CardTitle className="text-2xl font-bold text-gray-900">
                Contact Information
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <a href="tel:+14807449683" className="flex items-center space-x-4 group" data-testid="contact-phone">
                <div className="bg-indigo-100 p-3 rounded-full group-hover:bg-indigo-200 transition-colors">
                  <Phone className="h-6 w-6 text-indigo-700" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Phone</h4>
                  <p className="text-gray-700 font-medium">(480) 744-9683</p>
                  <p className="text-sm text-gray-600">Call or text Ria to place your order</p>
                </div>
              </a>

              <a href="mailto:rolluplumpiaco@gmail.com" className="flex items-center space-x-4 group" data-testid="contact-email">
                <div className="bg-indigo-100 p-3 rounded-full group-hover:bg-indigo-200 transition-colors">
                  <Mail className="h-6 w-6 text-indigo-700" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Email</h4>
                  <p className="text-gray-700 font-medium">rolluplumpiaco@gmail.com</p>
                  <p className="text-sm text-gray-600">We'll respond within 24 hours</p>
                </div>
              </a>

              <div className="flex items-center space-x-4" data-testid="contact-location">
                <div className="bg-indigo-100 p-3 rounded-full">
                  <MapPin className="h-6 w-6 text-indigo-700" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Location</h4>
                  <p className="text-gray-700 font-medium">El Mirage, Arizona</p>
                  <p className="text-sm text-gray-600">Serving the greater Phoenix area</p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Quick Order Info */}
          <Card className="bg-gradient-to-r from-yellow-100 to-amber-100 border-2 border-yellow-300">
            <CardHeader>
              <CardTitle className="text-2xl font-bold text-gray-900">
                Quick Order Tips
              </CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-3 text-gray-800 text-base">
                <li>• Call or text (480) 744-9683 for fastest service</li>
                <li>• Catering orders need 48-hour notice</li>
                <li>• Both frozen packs and freshly fried rolls available</li>
                <li>• Free delivery within 15 miles</li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
